import {
  Box, DashboardModuleListItem, Text,
} from '@domain-group/suit-theme'

import { formatDate } from '@domain-group/javascript-utils'

import useCurrentUser from '@hooks/useCurrentUser'
import useOrder from '@hooks/useOrder'

import ScopedConditionalContent from '@components/ScopedConditionalContent'

import { OrderModel } from '@models/order'

interface OrderListItemHeaderProps {
  currentUserPayload: ReturnType<typeof useCurrentUser>,
  order: OrderModel,
}

const OrderListItemHeader = (props: OrderListItemHeaderProps) => {
  const {
    currentUserPayload,
    order,
    order: { dates, id: orderId },
  } = props

  const { isBrandUser } = currentUserPayload

  const useOrderPayload = useOrder(order)

  const {
    agency,
    callbacks: { editOrderModal },
    campaign,
  } = useOrderPayload

  const approvalDate = dates?.approval?.date_time || ''
  const createdDate = dates?.created?.date_time || ''
  const date = isBrandUser ? createdDate : approvalDate

  const formattedDate = date
    ? formatDate(date, 'dd/MM/yyyy HH:mm', "ccc dd LLL y 'at' h:mma")
    : 'Not Approved'

  return (
    <DashboardModuleListItem
      key={agency?.title}
      title={(
        <Box>
          <Text variant="ellipsis">
            {agency?.title}
          </Text>

          {campaign?.title && (
            <Text color="faintGrey" marginLeft="small" variant="ellipsis">
              {`(${campaign?.title})`}
            </Text>
          )}

        </Box>
      )}
    >
      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.TertiaryText>
        {`${formattedDate} (Order #${orderId})`}
        {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.TertiaryText>

      <ScopedConditionalContent permittedRoleTitles={['Admin', 'Support', 'Provider Director']}>
        {/*
         // @ts-expect-error TS2339 */}
        <DashboardModuleListItem.Actions>
          {/*
           // @ts-expect-error TS2339 */}
          <DashboardModuleListItem.Icon
            onClick={() => editOrderModal()}
            type="edit"
          />
          {/*
         // @ts-expect-error TS2339 */}
        </DashboardModuleListItem.Actions>
      </ScopedConditionalContent>
    </DashboardModuleListItem>
  )
}

export default OrderListItemHeader
